import { WithInvalidFieldsContext } from 'components/common-form/contexts/WithInvalidFieldsContext';
import type { SecondaryMarketKeys, SecondaryMarketKeysPrefix } from 'locales/secondaryMarketKeys';
import { FC } from 'react';
import type { SecondaryMarketQuoteRtForm } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';

import { GenericErrorBoundary } from '../../common-form/builder/form/GenericErrorBoundary';
import { TabFatalError } from '../shared/TabFatalError';
import { Toolbar } from '../shared/toolbar/Toolbar';
import { QuoteRealtimeFormSidePanel } from './components/sidePanel';
import type { QuoteRealtimeFormProps } from './QuoteRealtimeForm.connect';
import { QuoteRealtimeFormDetails as ProductDetails } from './QuoteRealtimeFormDetails';
import { QuoteRealtimeFormProductSummary as ProductSummary } from './QuoteRealtimeFormProductSummary';
import { QuoteRealtimeFormSkeleton } from './skeletons';

export const QuoteRealtimeForm: FC<QuoteRealtimeFormProps> = ({
  tabId,
  onRetryProductFetch,
  validationErrors,
  hasFatalError,
  isLoading,
}) => {
  if (isLoading) {
    return <QuoteRealtimeFormSkeleton />;
  }
  if (hasFatalError) {
    return <TabFatalError onRetry={onRetryProductFetch} />;
  }
  return (
    <WithInvalidFieldsContext<SecondaryMarketQuoteRtForm, SecondaryMarketKeys, SecondaryMarketKeysPrefix>
      validationErrors={validationErrors}
    >
      <div
        className="d-flex flex-column flex-lg-row bg-lvl3 h-100 overflow-hidden"
        data-e2e="secondary-market-container"
      >
        <div className="col-xl-9 col-lg-7 d-flex flex-column overflow-auto p-0">
          <Toolbar type="realtimeQuote" />
          <div className="d-flex flex-column flex-lg-row m-1">
            <div className="col-xl-6 p-2">
              <GenericErrorBoundary key={tabId}>
                <ProductSummary tabId={tabId} />
              </GenericErrorBoundary>
            </div>
            <div className="col-xl-6 py-2 ps-0 pe-2">
              <GenericErrorBoundary key={tabId}>
                <ProductDetails tabId={tabId} />
              </GenericErrorBoundary>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-5 h-100 p-lg-0">
          <GenericErrorBoundary key={tabId}>
            <QuoteRealtimeFormSidePanel tabId={tabId} />
          </GenericErrorBoundary>
        </div>
      </div>
    </WithInvalidFieldsContext>
  );
};
QuoteRealtimeForm.displayName = 'QuoteRealtimeForm';
